import { initReactI18next } from 'react-i18next';

import en from '@locales/en.js';
import fr from '@locales/fr.js';
import i18n from 'i18next';

i18n.use(initReactI18next).init({
  react: {
    useSuspense: false,
  },
  lng: 'fr',
  keySeparator: false,
  interpolation: { escapeValue: false },
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
});

export default i18n;
